<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div :class="$style.root">
    <div :class="$style.wrapper">
      <div :class="[$style.title, $style[`title-${$i18n.locale}`]]">
        {{ t("block.extCodeInBrowser.title") }}
      </div>
      <div :class="$style.image">
        <span>
          <nuxt-img
            src="/img/block-ext-confirm.png"
            width="800"
            height="671"
            format="webp"
            sizes="sm:100vw md:400px lg:800px"
            aria-label="Top up by crypto and more"
            placeholder
            loading="lazy"
          />
        </span>
        <nuxt-img
          src="/img/block-ext-null.png"
          width="265"
          height="1084"
          format="webp"
          sizes="sm:100vw md:265px"
          aria-label="Top up by crypto and more"
          placeholder
          class="w-full px-2 xs:pl-4 xs:pr-8 md:px-0 lg:w-[calc(100%-32px)]"
          loading="lazy"
        />
      </div>
      <div
        v-if="$slots.action"
        :class="$style.action"
      >
        <slot name="action" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  @apply rounded-[40px] relative flex flex-col md:flex-row md:items-center lg:items-start lg:flex-col w-full overflow-hidden;
  @apply px-[30px] pt-10 pb-10 md:pt-10 md:pb-10 lg:px-[30px] lg:py-10;
  @apply min-h-[500px] xxs:min-h-[530px] md:min-h-[268px] lg:min-h-[530px];
  @apply bg-neutral-900 text-white;
}

.wrapper {
  @apply w-full h-full flex flex-col gap-5 justify-between md:w-7/12 md:mr-auto md:pr-8 md:justify-center lg:justify-between lg:pr-0 lg:mr-0 lg:w-full;
}

.image {
  @apply w-full mx-auto h-[261px] z-0 relative;

  @screen md {
    @apply w-[260px] absolute right-0 translate-y-6 -translate-x-12;
  }

  @screen lg {
    @apply relative rotate-[0deg] translate-y-0 translate-x-0;
  }

  @screen xl {
    @apply w-full;
  }

  & span {
    @apply absolute top-0 right-0 z-10 translate-y-[45%] translate-x-2 xxs:translate-y-[15%] xs:translate-y-[8%] w-full xs:w-11/12;

    & img {
      @apply w-full;
    }

    @screen md {
      @apply w-[261px] translate-y-16 translate-x-6;
    }

    @screen lg {
      @apply translate-y-[28%] -translate-x-1;
    }

    @screen xl {
      @apply translate-x-1;
    }
  }
}

.title {
  @apply font-extrabold leading-none mb-5 z-10;
  @apply text-[32px] xxs:text-[36px];
  &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
  &-be,
  &-bg,
  &-it,
  &-ua,
  &-zh,
  &-de,
  &-bg,
  &-ru,
  &-ja,
  &-th,
  &-pl,
  &-hi,
  &-ar,
  &-bn,
  &-ko,
  &-vi,
  &-sw{
    @apply text-[32px] xxs:text-[36px];
  }
  &-zh {
    @apply leading-[1.2];
  }
  &-ja {
    @apply leading-[1.2];
  }
  &-tr {
    @apply text-[32px] xxs:text-[32px];
  }
  &-pt,
  &-fr,
  &-es {
    @apply text-[24px] xxs:text-[30px] 414:text-[32px] lg:text-[28px] xl:text-[32px];
  }
}

.action {
  @apply w-full z-10;
}
</style>
